export const EMAIL_MIN_LENGTH = 8;
export const EMAIL_MAX_LENGTH = 50;
export const EMAIL_PATTERN = /^[a-z.]+[0-9]*[a-z.]*@[a-z]{2,}\.[a-z]{2,3}$/im;

export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 51;
export const NAME_PATTERN = /^[a-z]{2,20}\s+[a-z]{2,30}$/im;

export const USERNAME_MIN_LENGTH = 2;
export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_PATTERN = /^[a-z0-9]{2,20}$/im;

export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 20;
